import React, { useEffect, useState } from 'react';
import { GET_FIRE_POLICY_VAR_DETAILS } from '../../queries';
// import useFetchQuery from '../../../../../../lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';
// import Loading from '../../../../../../lib/layout/loading';
import { Loading } from 'quanta-flows/modules/layout';
// import Error from '../../../../../../lib/layout/error';
import { Error } from 'quanta-flows/modules/layout';
import RiskLocationhomebuildingonly from './risk-location-floater';
import RiskLocationNonFloaterDetails from './risk-location-non-floater';
import RiskLocationhomecontentsonly from './stock-location-modal';

export default function RiskLocation(props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [fireQuote, setFireQuote] = useState(null);
  const fetchQuery = useFetchQuery();

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      setLoading(true);
      fetchQuery({
        query: GET_FIRE_POLICY_VAR_DETAILS,
      })
        ?.then((response) => {
          if (isMounted) {
            setError(null);
            setLoading(false);
            setFireQuote(response?.data?.fireQuote);
          }
        })
        ?.catch((error) => {
          setError(error?.message);
          setLoading(false);
          setFireQuote(null);
        });
    }
    return () => {
      isMounted = false;
    };
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen">
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen">
        <Error error={error} />
      </div>
    );
  }
 return (
    <>
      {fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.value
        ?.toString()
        ?.toLowerCase() === 'home building and home contents' ? (
        <RiskLocationNonFloaterDetails
          {...{
            ...props,
            fireQuote,
          }}
        />
      ) : fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.value
      ?.toString()
      ?.toLowerCase() === 'home building only' ?
      (
        <RiskLocationhomebuildingonly
          {...{
            ...props,
            fireQuote,
          }}
        />

      ): (
        <RiskLocationhomecontentsonly
        {...{
          ...props,
          fireQuote,
        }}
        
      />
      )
    }
    </>
  );
}
